export default __webpack_public_path__ + "static/media/redTheme-boy.a0cd1649.svg";